// extracted by mini-css-extract-plugin
module.exports = {"distance":"_7a3fb80146--distance--rbSnq","icon":"_7a3fb80146--icon--ZWOLE"};